var map = {
	"./assets/ajinomotoWheel/gameNameMobile.png": 3587,
	"./assets/bmiValentinesDayWheel/gameNameMobile.png": 257,
	"./assets/classicWheel/gameNameMobile.png": 1574,
	"./assets/estivalWheel/gameNameMobile.png": 2694,
	"./assets/grippleWheel/gameNameMobile.png": 8590,
	"./assets/losteWheel/gameNameMobile.png": 7473,
	"./assets/sirhaWheel/gameNameMobile.png": 1590,
	"./assets/stickAndPlayWheel/gameNameMobile.png": 6430
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 683;